// Stage 2 "Dashboard" · 2.3 ONE DASHBOARD (agent E) — the firm dashboard strings, EN + AR.
// Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_DS_E = {
  en: {
    fd: {
      title: "Dashboard",
      subtitleFirm: "The firm's engagements at a glance",
      subtitleOwn: "Your engagements at a glance",
      asOf: "As of",
      loading: "Loading the dashboard…",
      loadFailed: "The dashboard could not be loaded.",
      retry: "Try again",
      view: { partner: "Firm view", manager: "Firm view (no fees)", preparer: "My engagements" },
      tiles: {
        stages: "Engagements by status",
        assembly: "Assembly due in 30 days",
        assemblyHint: "Report date + 60 days, not yet locked",
        ready: "Ready to lock",
        readyOf: "{n} of {total}",
        review: "Open review points",
        pm: "Uncorrected at or over PM",
        overdue: "Overdue",
        due: "Due",
        none: "None",
        showList: "Show the list",
        hideList: "Hide the list",
      },
      stage: { planning: "Planning", fieldwork: "Fieldwork", completion: "Completion", reporting: "Reporting", locked: "Locked" },
      opinion: { unmodified: "Unmodified", qualified: "Qualified", adverse: "Adverse", disclaimer: "Disclaimer", not_concluded: "Not concluded" },
      portfolio: {
        title: "Portfolio",
        client: "Client", status: "Status", tested: "Tested items", signoffs: "Sign-offs", lock: "Ready to lock",
        report: "Report", pm: "Uncorrected vs PM", rp: "Review points",
        ready: "Ready", openItems: "{n} open", warnings: "{n} warnings", notDated: "Not dated",
        noPm: "PM not set", empty: "No engagements to show.",
      },
      billing: {
        title: "Fee, cost and over-run",
        client: "Client", cur: "Cur.", fee: "Fee", budget: "Budget hrs", actual: "Actual hrs", cost: "Cost to date",
        ai: "AI use", margin: "Fee − cost", overrun: "Over-run",
        within: "Within budget", over: "Over by {h}", noBudget: "No budget set", rateNotSet: "Rate not set: {h}",
        total: "Total {cur}", aiFirm: "Firm-level AI use (no engagement)", aiUsd: "USD {n}",
        empty: "No fee or cost data yet.", unspecified: "Not set", nEng: "{n} engagements",
      },
      staff: {
        title: "Staff time", staff: "Staff", grade: "Grade", engagement: "Engagement", hours: "Hours",
        empty: "No time recorded.",
      },
      heat: {
        title: "Risk heat map",
        legend: "Legend", significant: "Significant", high: "High", medium: "Medium", low: "Low",
        none: "No risks linked to FS heads",
        risks: "{n} risks", empty: "No engagements to show.",
      },
      ms: {
        title: "Misstatements vs materiality",
        hint: "Uncorrected aggregate (W9) against performance materiality",
        ofPm: "{pct}% of PM", noPm: "PM not set", empty: "No engagements to show.",
      },
      myTime: {
        title: "My time, last 7 days", deleted: "Deleted engagements", total: "Total", empty: "No time in the last 7 days.",
      },
      hours: "{h} h",
    },
  },
  ar: {
    fd: {
      title: "لوحة التحكم",
      subtitleFirm: "ارتباطات المكتب في لمحة",
      subtitleOwn: "ارتباطاتك في لمحة",
      asOf: "حتى",
      loading: "جارٍ تحميل لوحة التحكم…",
      loadFailed: "تعذّر تحميل لوحة التحكم.",
      retry: "أعد المحاولة",
      view: { partner: "عرض المكتب", manager: "عرض المكتب (بدون الأتعاب)", preparer: "ارتباطاتي" },
      tiles: {
        stages: "الارتباطات حسب الحالة",
        assembly: "تجميع الملف خلال 30 يومًا",
        assemblyHint: "تاريخ التقرير + 60 يومًا، لم يُقفل بعد",
        ready: "جاهز للإقفال",
        readyOf: "{n} من {total}",
        review: "نقاط المراجعة المفتوحة",
        pm: "غير مصحّح عند أو فوق الأهمية النسبية للأداء",
        overdue: "متأخر",
        due: "يستحق",
        none: "لا شيء",
        showList: "عرض القائمة",
        hideList: "إخفاء القائمة",
      },
      stage: { planning: "التخطيط", fieldwork: "العمل الميداني", completion: "الإكمال", reporting: "التقرير", locked: "مقفل" },
      opinion: { unmodified: "غير معدل", qualified: "متحفظ", adverse: "معارض", disclaimer: "امتناع", not_concluded: "لم يُستنتج" },
      portfolio: {
        title: "المحفظة",
        client: "العميل", status: "الحالة", tested: "البنود المفحوصة", signoffs: "الاعتمادات", lock: "جاهز للإقفال",
        report: "التقرير", pm: "غير مصحّح مقابل الأهمية النسبية للأداء", rp: "نقاط المراجعة",
        ready: "جاهز", openItems: "{n} مفتوح", warnings: "{n} تحذيرات", notDated: "بلا تاريخ",
        noPm: "لم تُحدّد الأهمية النسبية للأداء", empty: "لا توجد ارتباطات للعرض.",
      },
      billing: {
        title: "الأتعاب والتكلفة والتجاوز",
        client: "العميل", cur: "العملة", fee: "الأتعاب", budget: "ساعات الموازنة", actual: "الساعات الفعلية", cost: "التكلفة حتى تاريخه",
        ai: "استخدام الذكاء الاصطناعي", margin: "الأتعاب − التكلفة", overrun: "التجاوز",
        within: "ضمن الموازنة", over: "تجاوز بـ {h}", noBudget: "لم تُحدّد موازنة", rateNotSet: "لم يُحدّد السعر: {h}",
        total: "الإجمالي {cur}", aiFirm: "استخدام الذكاء الاصطناعي على مستوى المكتب (بدون ارتباط)", aiUsd: "{n} دولار",
        empty: "لا توجد بيانات أتعاب أو تكلفة بعد.", unspecified: "غير محددة", nEng: "{n} ارتباطات",
      },
      staff: {
        title: "وقت الفريق", staff: "الموظف", grade: "الدرجة", engagement: "الارتباط", hours: "الساعات",
        empty: "لم يُسجَّل وقت.",
      },
      heat: {
        title: "خريطة حرارة المخاطر",
        legend: "المفتاح", significant: "جوهري", high: "عالٍ", medium: "متوسط", low: "منخفض",
        none: "لا توجد مخاطر مرتبطة ببنود القوائم المالية",
        risks: "{n} مخاطر", empty: "لا توجد ارتباطات للعرض.",
      },
      ms: {
        title: "التحريفات مقابل الأهمية النسبية",
        hint: "إجمالي غير المصحّح (W9) مقابل الأهمية النسبية للأداء",
        ofPm: "{pct}% من الأهمية النسبية للأداء", noPm: "لم تُحدّد الأهمية النسبية للأداء", empty: "لا توجد ارتباطات للعرض.",
      },
      myTime: {
        title: "وقتي، آخر 7 أيام", deleted: "ارتباطات محذوفة", total: "الإجمالي", empty: "لا وقت في آخر 7 أيام.",
      },
      hours: "{h} ساعة",
    },
  },
};

export default I18N_DS_E;
